import { financialRowTypesInversed } from '@teinor/erp/types/company/order/general'
import ITHeaderText from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { getCurrencySymbol } from '../../../../../../../../utils/globals/price'
import { returnClassOfSpanTemplate } from '../../../../../../../../utils/globals/tailwind'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import useOrderFinancialRowTypesDict from '../../../../../../../../utils/hooks/orders/useOrderFinancialRowTypesDict'
import '../sellHeader.sass'


interface SellReadOnlyHeaderFinancialRowsProps extends InputTableLeftTabsProps { }

const SellReadOnlyHeaderFinancialRows: React.FC<SellReadOnlyHeaderFinancialRowsProps> = ({ headerData, handleChange }) => {
    const { t } = useTwinTranslation()
    const financialRows = headerData.OrderFinancialRows
    const currencyHeaderId = headerData.CurrencyId
    const financialRowsSections: FormRender<any> = []
    const financialRowTypesDict = useOrderFinancialRowTypesDict()

    const items: TwinDictionary = { 0: { name: '%' }, 1: { name: getCurrencySymbol(currencyHeaderId) } }

    if (financialRows?.length) {
        for (let key in financialRows) {
            const financialRow = financialRows[key]
            const financialRowType = financialRow?.financialRowType === financialRowTypesInversed['discountForTotalFooter'] ? financialRowTypesInversed['discountWithCosts'] : financialRow?.financialRowType
            financialRowsSections.push({
                cols: 2,
                title: t('discountOrRecharge', 'Descuento o recargo'),
                elements: [
                    {
                        name: 'quantity',
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('quantity', 'Cantidad')} value={financialRow?.quantity + ' ' + items[financialRow?.calculationType].name} className={returnClassOfSpanTemplate(1)} />
                    },
                    {
                        name: key + '-financialRowType',
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('type', 'Tipo')} value={financialRowTypesDict[financialRowType].name} className={returnClassOfSpanTemplate(1)} />
                    },
                ]
            }, {
                cols: 1,
                title: '',
                elements: [
                    {
                        name: 'beforeTax',
                        component: 'Custom',
                        render: ({ value }) => <ITHeaderText label={t('taxes', 'Impuestos')} value={financialRow.beforeTax ? t('beforeTax', 'Antes de impuestos') : t('afterTax', 'Después de impuestos')} className={returnClassOfSpanTemplate(1)} />
                    },
                ]
            })
        }
    }
    const sections: FormRender<any> = [
        ...financialRowsSections,
    ]
    return (
        <InputTableLeftColumnForm form={sections} headerData={headerData} handleChange={handleChange} />
    )
}

export default SellReadOnlyHeaderFinancialRows